import React from 'react';

interface PageLoadingStateProps {
    /** When set, renders the error state instead of the loading spinner. */
    error?: string | null;
    /** Heading shown while loading. Ignored when `error` is set. */
    title?: string;
    /** Supporting text shown while loading. Ignored when `error` is set. */
    hint?: string;
}

/**
 * Shared loading/error state for pages nested under ProjectDataLoader (and
 * any other page that needs the same look). Reuses the `.app-empty` /
 * `.app-empty-spinner` markup so every project-scoped page shows one
 * consistent spinner instead of a bespoke one per page. Renders just the
 * `.app-empty` block — callers provide their own layout wrapper (e.g.
 * `.app-canvaswrap`) since that varies by call site.
 */
export default function PageLoadingState({ error, title = 'Loading…', hint }: PageLoadingStateProps) {
    if (error) {
        return (
            <div className='app-empty'>
                <p className='app-empty-title'>Project not found</p>
                <p className='app-empty-hint'>{error}</p>
            </div>
        );
    }

    return (
        <div className='app-empty'>
            <div className='app-empty-spinner' aria-hidden='true'>
                <div className='app-empty-spinner-circle' />
            </div>
            <p className='app-empty-title'>{title}</p>
            {hint && <p className='app-empty-hint'>{hint}</p>}
        </div>
    );
}
